import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  pageContent: {
    backgroundColor: "#F0F2F5",
    width: "100%",
    height: "80%",
    borderRadius: "10px 10px 10px 10px",
    boxSizing: "border-box",
    paddingTop: "16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    "@media (max-width: 550px)": {
      paddingTop: 0
    }
  },
  contentpadding: {
    paddingLeft: 10,
    "@media (max-width: 550px)": {
      padding: 0
    }
  },
  paddingleftmodal: {
    paddingLeft: "3%",
    marginBlock: "21px 26px",
    display: "flex",
    gap: "10px",
    width: "100%"
  },
  label: {
    fontWeight: "500",
    fontSize: "16px"
  },
  profilecontainer: {
    backgroundColor: "#F5F6F7",
    width: "100%",
    height: 258,
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 22
  },
  picker: {
    opacity: 0,
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  uploadflex: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  uploadicon: {
    fontSize: 16,
    color: "#101928"
  },
  uploadtitle: {
    fontSize: 16,
    color: "#101928",
    marginBottom: 0,
    marginTop: 0
  },
  uploadsubtitle: {
    color: "#98A2B3",
    fontsize: 16,
    marginBottom: 0,
    marginTop: 0
  },
  remove: {
    color: "red",
    position: "relative",
    alignItems: "center",
    gap: 4,
    padding: "6px 8px",
    boxSizing: "border-box",
    marginLeft: 3,
    zIndex: 50,
    backgroundColor: "white",
    border: "1px solid #98A2B3",
    borderRadius: 4,
    display: "flex",
    fontWeight: "bold"
  },
  clickUpload: {
    color: "#0065FF",
    fontWeight: 600,
    fontSize: 14
  },
  uploadsubtitless: {
    color: "#98A2B3",
    fontsize: 16,
    marginBottom: 0,
    alignItems: "center",
    marginTop: 0
  },
  uploadtitles: {
    fontSize: 16,
    fontWeight: 400,
    color: "#475367",
    marginBottom: 0,
    marginTop: 0
  },
  uploadicons: {
    fontSize: 16,
    color: "#101928"
  },
  uploadbutton: {
    backgroundColor: "#CB1A14",
    width: 120,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    gap: 5,
    color: "white",
    position: "relative",
    zIndex: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center"
  },
  pickercontainer: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    maxHeight: 70,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginBottom: 20,
    marginTop: 15
  },
  pickercontainers: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    maxHeight: 70,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginBottom: 20,
    marginTop: 15
  },
  columnItems: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "auto",
    textAlign: "center"
  },
  pickercontainerss: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    height: 113,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginBottom: 20
  },
  btnspace: {
    marginTop: 15
  },
  downloadbutton: {
    marginTop: 20,
    textAlign: "center"
  },
  // profileform: {
  //   padding: "2%"
  // },
  camera: {
    color: "white",
    width: "14px!important"
  },
  profilepicker: {
    opacity: 0,
    width: 25,
    height: 25,
    cursor: "pointer",
    position: "absolute"
  },
  imageviewer: {
    width: "120px",
    height: "120px",
    backgroundColor: "white",
    borderRadius: "50%",
    position: "relative"
  },
  textandimg: {
    position: "relative",
    borderRadius: "6px",
    border: "1px solid hsl(0, 0%, 80%)",
    backgroundColor: "white",
    height: "150px",
    "& textarea": {
      width: "100%",
      height: "150px",
      boxSizing: "border-box",
      background: "none",
      border: "0px",
      paddingBlock: "10px",
      paddingLeft: "10px",
      paddingRight: "35px",
      color: "black"
    }
  }
}));
